import { Routes } from '@angular/router';
import { LoginRouteGuardService } from './services/_core/login-route-guard/login-route-guard.service';
import { RoleGuardService } from './services/_core/role-guard/role-guard.service';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'login',
    pathMatch: 'full',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'help',
    loadComponent: () => import('./pages/_core/help/help.page').then( m => m.HelpPage)
  },
  {
    path: 'share',
    loadComponent: () => import('./pages/_core/share/share.page').then( m => m.SharePage)
  },
  {
    path: 'check-for-updates',
    loadComponent: () => import('./pages/_core/check-for-updates/check-for-updates.page').then( m => m.CheckForUpdatesPage)
  },
  {
    path: 'help-forgot-pwd',
    loadComponent: () => import('./pages/_core/help-forgot-pwd/help-forgot-pwd.page').then( m => m.HelpForgotPwdPage)
  },
  {
    path: 'feedback-modal',
    loadComponent: () => import('./pages/_core/feedback-modal/feedback-modal.page').then( m => m.FeedbackModalPage)
  },
  {
    path: 'my-account',
    canActivate: [LoginRouteGuardService],
    loadComponent: () => import('./pages/_core/my-account/my-account.page').then( m => m.MyAccountPage)
  },
  {
    path: 'language-modal',
    loadComponent: () => import('./pages/_core/language-modal/language-modal.page').then( m => m.LanguageModalPage)
  },
  {
    path: 'language-popover',
    loadComponent: () => import('./pages/_core/language-popover/language-popover.page').then( m => m.LanguagePopoverPage)
  },
  {
    path: 'language-translator',
    loadComponent: () => import('./pages/_core/language-translator/language-translator.page').then( m => m.LanguageTranslatorPage)
  },
  {
    path: 'patient-landing',
    redirectTo: 'patient-landing/BMCLD',
    pathMatch: 'full',
  },
  {
    path: 'patient-landing/:siteCode',
    loadComponent: () => import('./pages/patient-landing/patient-landing.page').then( m => m.PatientLandingPage)
  },
  {
    path: 'course-details/:id',
    loadComponent: () => import('./pages/course-details/course-details.page').then( m => m.CourseDetailsPage)
  },
  {
    path: 'course-details',
    loadComponent: () => import('./pages/course-details/course-details.page').then( m => m.CourseDetailsPage)
  },
  {
    path: 'client-checkout',
    loadComponent: () => import('./pages/client-checkout/client-checkout.page').then( m => m.ClientCheckoutPage)
  },
  {
    path: 'client-profile',
    loadComponent: () => import('./pages/client-profile/client-profile.page').then( m => m.ClientProfilePage)
  },
  {
    path: 'cart',
    loadComponent: () => import('./pages/cart/cart.page').then( m => m.CartPage)
  },
  // Public class pages
  {
    path: 'class-listing',
    loadComponent: () => import('./pages/class-listing/class-listing.page').then( m => m.ClassListingPage),
    data: { allowPublic: true }
  },
  {
    path: 'class-register/:id',
    loadComponent: () => import('./pages/class-register/class-register.page').then( m => m.ClassRegisterPage),
    data: { allowPublic: true }
  },
  // Educator/Admin pages
  {
    path: 'class-management',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/class-management/class-management.page').then( m => m.ClassManagementPage),
    data: { roles: ['ADMIN', 'SYSADMIN', 'EDITOR'] }
  },
  {
    path: 'registration-management/:classId',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/registration-management/registration-management.page').then( m => m.RegistrationManagementPage),
    data: { roles: ['ADMIN', 'SYSADMIN', 'EDITOR'] }
  },
  {
    path: 'attendance-dashboard',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/attendance-dashboard/attendance-dashboard.page').then( m => m.AttendanceDashboardPage),
    data: { roles: ['ADMIN', 'SYSADMIN', 'EDITOR'] }
  },
  {
    path: 'attendance-dashboard/:classId',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/attendance-dashboard/attendance-dashboard.page').then( m => m.AttendanceDashboardPage),
    data: { roles: ['ADMIN', 'SYSADMIN', 'EDITOR'] }
  },
  {
    path: 'financial-reporting',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/financial-reporting/financial-reporting.page').then( m => m.FinancialReportingPage),
    data: { roles: ['ADMIN', 'SYSADMIN'] }
  },
  {
    path: 'waitlist-management',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/waitlist-management/waitlist-management.page').then( m => m.WaitlistManagementPage),
    data: { roles: ['ADMIN', 'SYSADMIN', 'EDITOR'] }
  },
  {
    path: 'waitlist-management/:classId',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/waitlist-management/waitlist-management.page').then( m => m.WaitlistManagementPage),
    data: { roles: ['ADMIN', 'SYSADMIN', 'EDITOR'] }
  },
  {
    path: 'bulk-messaging',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/bulk-messaging/bulk-messaging.page').then( m => m.BulkMessagingPage),
    data: { roles: ['ADMIN', 'SYSADMIN', 'EDITOR'] }
  },
  {
    path: 'bulk-messaging/:classId',
    canActivate: [LoginRouteGuardService, RoleGuardService],
    loadComponent: () => import('./pages/bulk-messaging/bulk-messaging.page').then( m => m.BulkMessagingPage),
    data: { roles: ['ADMIN', 'SYSADMIN', 'EDITOR'] }
  },
  // Confirmation pages (public)
  {
    path: 'registration-confirmation/:id',
    loadComponent: () => import('./pages/registration-confirmation/registration-confirmation.page').then( m => m.RegistrationConfirmationPage),
    data: { allowPublic: true }
  },
  {
    path: 'waitlist-confirmation/:id',
    loadComponent: () => import('./pages/waitlist-confirmation/waitlist-confirmation.page').then( m => m.WaitlistConfirmationPage),
    data: { allowPublic: true }
  },
  {
    path: 'login-modal',
    loadComponent: () => import('./pages/login-modal/login-modal.page').then( m => m.LoginModalPage)
  },
  {
    path: 'redirect',
    loadComponent: () => import('./pages/redirect/redirect.page').then( m => m.RedirectPage)
  },
  {
    path: 'manage-locations',
    loadComponent: () => import('./pages/manage-locations/manage-locations.page').then( m => m.ManageLocationsPage)
  },
  {
    path: 'manage-sites',
    loadComponent: () => import('./pages/manage-sites/manage-sites.page').then( m => m.ManageSitesPage)
  },
];
